import { matchPath } from 'react-router-dom';
import { navigationPages, PageDescription, SubmenuType } from '@/config';

const isPathMatch = (path: string, currentPath: string): boolean =>
  !!matchPath({ path, end: true }, currentPath);

export const findCurrentPage = (
  currentPath: string,
): PageDescription | SubmenuType | null => {
  const findPageInSubMenu = (
    subMenu: SubmenuType[],
    path: string,
    parentPage: PageDescription | SubmenuType,
    nestingLevel: number,
  ): {
    found: SubmenuType;
    parent: PageDescription | SubmenuType;
    nestingLevel: number;
  } | null => {
    for (const subItem of subMenu) {
      if (isPathMatch(subItem.path, path)) {
        return { found: subItem, parent: parentPage, nestingLevel };
      }

      if (subItem.subMenu) {
        const nestedResult = findPageInSubMenu(
          Object.values(subItem.subMenu),
          path,
          subItem,
          nestingLevel + 1,
        );
        if (nestedResult) {
          return nestedResult;
        }
      }
    }
    return null;
  };

  for (const item of Object.values(navigationPages)) {
    if (isPathMatch(item.path, currentPath)) {
      return item;
    }

    if (item.subMenu) {
      const subMenuArray = Object.values(item.subMenu);
      const searchResult = findPageInSubMenu(
        subMenuArray,
        currentPath,
        item,
        1,
      );
      if (searchResult) {
        if (searchResult.nestingLevel === 1) {
          return searchResult.found;
        }
        return searchResult.parent;
      }
    }
  }

  return null;
};
